import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable, Subscription } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { MediaMatcher } from '@angular/cdk/layout';
import { PopupDetailGeoposService } from '../../../../services/Popup-Detail-Geopos.service';
import { DataNamesDTO } from 'src/app/features/map-features/sections/locations-section/models/DataNamesDTO';
import { LocationsService } from 'src/app/features/map-features/sections/locations-section/services/Locations.service';

import { environment } from "src/environments/environment";

@Component({
  selector: "popup-detail-geopos",
  templateUrl: "./popup-detail-geopos.component.html",
  styleUrls: ["./popup-detail-geopos.component.css"],
  animations: [
    trigger('slideInOut', [
      state('in-l', style({ opacity: 1, width: '65%' })),
      state('in-m', style({ opacity: 1, width: '55%' })),
      state('out', style({ opacity: 0, overflow: 'hidden', width: '0%' })),
      transition('in-l <=> out', animate('200ms ease-in-out')),
      transition('in-m <=> out', animate('200ms ease-in-out'))
    ])
]
})
export class PopupDetailGeoposComponent implements OnInit, OnDestroy {
  @Input() $isVisiblePopupMap: boolean;
  Title: string;
  Keys: string[];
  KeyNames: DataNamesDTO[] = [];
  Values: string[];
  LastUpdate: string;
  Address: string;
  private $Title: Observable<string> = new Observable<string>();
  private $Keys: Observable<string[]> = new Observable<string[]>();
  private $Values: Observable<string[]> = new Observable<string[]>();
  private $LastUpdate: Observable<string> = new Observable<string>();
  private $Address: Observable<string> = new Observable<string>();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  Suscription_GetDataNames: Subscription;
  subscription_Title: Subscription;
  subscription_Keys: Subscription;
  subscription_Values: Subscription;
  subscription_LastUpdate: Subscription;
  subscription_Address: Subscription;

  constructor(private popupDetailGeoposService: PopupDetailGeoposService, private locationService: LocationsService, media: MediaMatcher, changeDetectorRef: ChangeDetectorRef,) {
    this.mobileQuery = media.matchMedia("(max-width: 950px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.$Title = this.popupDetailGeoposService.getTitle();
    this.subscription_Title = this.$Title.subscribe((element) =>{
      this.Title = "";
      this.Title = element
    });
     this.$LastUpdate = this.popupDetailGeoposService.getLastUpdate();
     this.subscription_LastUpdate = this.$LastUpdate.subscribe((element) => {
       this.LastUpdate = "";
       this.LastUpdate = element;
     });
     this.$Address = this.popupDetailGeoposService.getAddress();
     this.subscription_Address = this.$Address.subscribe((element) => {
       this.Address = "";
       this.Address = element;
     });
    this.$Keys = this.popupDetailGeoposService.getKeys();
    this.subscription_Keys = this.$Keys.subscribe((element) => {
      this.Keys = [];
      this.Keys = element;
      //Obtiene desde la base los nombres usables y las imagenes de las llaves existentes
      this.Suscription_GetDataNames = this.locationService.getDataNames(element).subscribe( data => {
        
        //Verifica si el array no es nulo, si sí, no se usa, para evitar desfases
        if (data.result != null) {
          this.KeyNames = data.result
        }
      });
      
    });
    this.$Values = this.popupDetailGeoposService.getValues();
    this.subscription_Values = this.$Values.subscribe((element) => {
      this.Values = [];
      this.Values = element;
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
      if(this.Suscription_GetDataNames)
      this.Suscription_GetDataNames.unsubscribe();
    if (this.subscription_Title)
      this.subscription_Title.unsubscribe();
    if (this.subscription_Keys)
      this.subscription_Keys.unsubscribe();
    if (this.subscription_Values)
      this.subscription_Values.unsubscribe();
    if (this.subscription_LastUpdate)
      this.subscription_LastUpdate.unsubscribe();
    if (this.subscription_Address)
      this.subscription_Address.unsubscribe();

  }

  //Obtiene el nombre usable según el nombre de la key
  getUsableName(keyName: string): string {
    const keyNameObject = this.KeyNames.find(item => item.keyName === keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName){
    const keyNameObject = this.KeyNames.find(item => item.keyName === keyName);
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  //Obtiene el nombre de la imagen según el nombre de la key y si no lo encuentra, le pone car
  getImageFileName(keyName: string): string {
    const keyNameObject = this.KeyNames.find(item => item.keyName === keyName);
    return keyNameObject ? keyNameObject.image : 'car.png';
  }

  // Para manejar cualquier otro error en la carga de la imagen
  onImageError(event: any) {
    event.target.src = '/assets/img/car.png'; 
  }

  getScreenSize(){
    if (this.mobileQuery.matches) {
      return "in-m";
    }
    else{
      return "in-l";
    }
  }

  CancelButton() {
    this.popupDetailGeoposService.setVisibilityPopup(false);
    if(!environment.production) console.log("cerrando popup");
  }
}
